import Vue from 'vue';
import ProductionToolContracting from './production-tool-contracting/production-tool-contracting';
Vue.component('production-tool-contracting', ProductionToolContracting);
